
<template>
 <BDropdown class="d-inline-block btn-drop me-2" 
                        toggle-class="header-item" 
                        right variant="white" 
                        aria-label="Korisnički meni"
                         id="my-btn-drop"
                         ref="dropdown"
                        menu-class="dropdown-menu-end">
                <template v-slot:button-content>
                    <div class='d-xl-none d-lg-none d-md-none d-sm-block d-block'>
                        <div class="avatar-customer-market d-inline-block ">
                            <span :class="`avatar-title bg-soft-success text-dark font-size-12 rounded-circle p-3`">
                                <span v-if="userStore.loggedIn !== false">{{ nameAvatar }}</span>      
                                <i v-else class="esei icon-user-solid text-muted"></i>              
                            </span>                        
                        </div>
                    <span class="d-inline-block ms-1 fw-medium font-size-14" v-if="userStore.loggedIn === false">Prijavi se</span>
                    <i class="esei icon-chevron-down font-size-12"></i>
                    </div>
                    <div class='d-xl-block d-lg-block d-md-block d-sm-none d-none'>
                        <div class="avatar-customer-market d-inline-block ">
                            <span :class="`avatar-title bg-soft-success text-dark font-size-12 rounded-circle p-3`">
                                <i class="esei icon-user-solid text-muted"></i>
                            </span>
                            
                        </div>
                    <span class="d-inline-block ms-1 fw-medium font-size-14"  >{{ emailUser}}</span>

                    <i class="esei icon-chevron-down d-none d-xl-inline-block font-size-12"></i>
                    </div>
                </template>
                <!-- item-->
                 <div class="dropdown-item" v-if="userStore.loggedIn !== false">
                    <i class="esei icon-envelope font-size-15 align-middle text-muted me-1"></i>
                    <span class="align-middle">{{ emailUser }}</span>                
                 <hr class="mt-3 mb-0"> 
                </div>
                  <nuxt-link class="dropdown-item "   v-for="m in menuByMenu()" :key="m.id" 
                              :to="m.link2">
                              <i :class="`${m.icon}  font-size-15 align-middle text-muted me-1`"></i>
                             <span class="align-middle">{{ m.label }}</span>                                      
                  </nuxt-link>    
                  <div v-if="userStore.loggedIn !== false">
                    <button class="dropdown-item" 
                             aria-label="Korisnički meni detalji"
                           v-for="m in menuOut()" 
                           :key="m.id" 
                           @click="logOutUser()"
                           :to="m.link2">                   
                              <i :class="`${m.icon}  font-size-15 align-middle text-muted me-1`"></i>
                             <span class="align-middle">{{ m.label }}</span>                                                            
                  </button> 
                  </div>
                  <div v-else>
                    <nuxt-link class="dropdown-item "   @click.native="dropdownDisable" v-for="m in menuIn()" :key="m.id" 
                           :to="m.link2">                      
                              <i :class="`${m.icon}  font-size-15 align-middle text-muted me-1`"></i>
                             <span class="align-middle">{{ m.label }}</span>                                                             
                   </nuxt-link>   
                  </div>
                  
                                          
            </BDropdown>   
            
</template>
 

<script setup>

const  { session, reset, update } = await useSession()

const router = useRouter();

import { BDropdown } from "bootstrap-vue-next";

import  { menuItems }  from '~/components/layouts/utils/menu-cms';

const menu = ref(menuItems)

import { useUserStore } from "~/stores/login/user";
 
const userStore = useUserStore();

const nuxtApp = useNuxtApp()

 
const menuByMenu = ( ) => {

  return menuItems.filter(x=> x.menu)
}

const menuOut = () => {
  return menuItems.filter(x=> x.logout)
}

const menuIn = () => {
  return menuItems.filter(x=> x.login)
}
 
const nameAvatar = computed(() => {
  if (!userStore.loggedIn || !userStore.user?.name) return ' '

  const parts = userStore.user.name.trim().split(/\s+/)
  const first = parts[0]?.[0] ?? ''
  const second = parts[1]?.[0] ?? ''

  return (first + second).toUpperCase() || ' '
})

const emailUser = computed(() => {
  if (!userStore.loggedIn || !userStore.user?.email) return ''

  const email = String(userStore.user.email).trim()
  const [local] = email.split('@')

  return local ? `${local}` : ''
})
const logOutUser = async () => {

const { success } = await userStore.logOutUser();

if(!success) return

await reset()

await update({ "token": ''})

userStore.initUser(null);

userStore.initloggedIn(false);


router.push('/')
}
</script>

